"use strict";

import Common from "../Common";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function ColourBrush() {
    // Constants.
    this.LINE_THICKNESS = 10;


    // Attributes.
    this._drawLayer = null;
    this._colour = null;
}
export default ColourBrush;
//module.exports               		= ColourBrush;
ColourBrush.prototype.constructor = ColourBrush;

//===================================================
//
// Public
//
//===================================================

ColourBrush.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;
};

//===================================================
//
// Private
//
//===================================================

ColourBrush.prototype._draw = function (start, end) {
    const dist = Math.round(Common.distanceBetween(start, end));
    const angle = Common.angleBetween(start, end);

    let lastX = Math.round(start.x + ( Math.sin(angle) * dist)), lastY = Math.round(start.y + ( Math.cos(angle) * dist ));

    for (let i = 0; i < dist; i += 3) {
        let x = Math.round(start.x + ( Math.sin(angle) * i ));
        let y = Math.round(start.y + ( Math.cos(angle) * i ));

        var radGrad = this._drawLayer.context.createRadialGradient(lastX, lastY, this.LINE_THICKNESS, x, y, 0);
        var rgbColour = Common.hexToRgb(this._colour);
        radGrad.addColorStop(0, "rgba( " + rgbColour.r + "," + rgbColour.g + "," + rgbColour.b + ", 0 )");
        radGrad.addColorStop(1, "rgba( " + rgbColour.r + "," + rgbColour.g + "," + rgbColour.b + ", 1 )");

        this._drawLayer.context.fillStyle = radGrad;
        this._drawLayer.context.fillRect(x - this.LINE_THICKNESS, y - this.LINE_THICKNESS, this.LINE_THICKNESS * 2, this.LINE_THICKNESS * 2);

        lastX = x;
        lastY = y;
    }

    this._drawLayer.onContext_Changed();
};

//===================================================
//
// Events
//
//===================================================

ColourBrush.prototype.onDrawBegan = function (point) {
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

ColourBrush.prototype.onDrawMoved = function (start, end) {
    this._draw(start, end);
};

ColourBrush.prototype.onDrawEnded = function () {
};

//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    ColourBrush.prototype,
    "colour",
    {
        get: function () {
            return this._colour;
        },
        set: function (a) {
            this._colour = a;
        }
    });